export const ptBROnboarding = {
  // Progress
  stepOf: 'Passo {{current}} de {{total}}',

  // Step 1: Welcome
  welcomeTitle: 'Bem-vindo ao Nomi!',
  welcomeMessage: 'Vamos configurar suas finanças em poucos passos. Você vai criar uma conta de pagamento, escolher categorias de gastos e, opcionalmente, adicionar sua primeira conta recorrente.',
  welcomeStart: 'Começar',
  welcomeSkip: 'Pular configuração',

  // Step 2: Account
  accountTitle: 'Crie sua primeira conta',
  accountMessage: 'De onde vem seu dinheiro? Adicione uma conta bancária ou cartão de crédito.',
  accountNameLabel: 'Nome da conta',
  accountNamePlaceholder: 'ex: Nubank',
  accountTypeLabel: 'Tipo de conta',
  accountTypeCreditCard: 'Cartão de Crédito',
  accountTypeBankAccount: 'Conta Bancária',
  accountTypeDebitCard: 'Cartão de Débito',
  accountTypeCash: 'Dinheiro',
  accountCreate: 'Criar Conta',
  accountCreating: 'Criando...',
  accountSkip: 'Pular',
  accountError: 'Falha ao criar conta. Tente novamente.',
  accountValidationName: 'Nome da conta é obrigatório',

  // Step 3: Categories
  categoriesTitle: 'Escolha suas categorias',
  categoriesMessage: 'Selecione as categorias de gastos que se encaixam no seu dia a dia. Você pode adicionar mais depois.',
  categoriesCreate: 'Criar Categorias',
  categoriesCreating: 'Criando...',
  categoriesSkip: 'Pular',
  categoriesError: 'Falha ao criar algumas categorias. Tente novamente.',
  categoriesNoneSelected: 'Selecione pelo menos uma categoria',
  // Preset category names
  categoryHousing: 'Moradia',
  categoryFood: 'Alimentação',
  categoryTransport: 'Transporte',
  categoryLeisure: 'Lazer',
  categoryHealth: 'Saúde',
  categoryEducation: 'Educação',
  categoryClothing: 'Vestuário',
  categorySubscriptions: 'Assinaturas',

  // Step 4: Bill (optional)
  billTitle: 'Adicione sua primeira conta',
  billMessage: 'Configure uma conta recorrente para o Nomi acompanhar todo mês. Este passo é opcional.',
  billDescriptionLabel: 'Descrição',
  billDescriptionPlaceholder: 'ex: Aluguel, Netflix, Internet',
  billAmountLabel: 'Valor',
  billStartDateLabel: 'Data de início',
  billCategoryLabel: 'Categoria',
  billSelectCategory: 'Selecione uma categoria',
  billAccountLabel: 'Conta de pagamento',
  billSelectAccount: 'Selecione uma conta',
  billCreate: 'Criar Conta',
  billCreating: 'Criando...',
  billSkip: 'Pular',
  billError: 'Falha ao criar conta. Tente novamente.',
  billValidationDescription: 'Descrição é obrigatória',
  billValidationAmount: 'Valor é obrigatório',
  billValidationStartDate: 'Data de início é obrigatória',

  // Step 5: Done
  doneTitle: 'Tudo pronto!',
  doneMessage: 'Suas finanças estão configuradas. Confira seu painel para ver tudo em ação.',
  doneSummaryAccounts: '{{total}} conta criada',
  doneSummaryCategories: '{{total}} categorias criadas',
  doneSummaryBills: '{{total}} conta recorrente criada',
  doneFinish: 'Ir para o Painel',
} as const;
